angular.module('agreements')
    .constant('AgreementCategoryConst', {
        eventUpdate: 'agreement-category.updated'
    })
    .factory('AgreementCategory', function ($resource) {
        return $resource('/crm/api/agreement-category/:id', { id: '@id' }, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        })
    })
    .service('AgreementCategoryService', function ($rootScope, modals, AgreementCategory, AgreementCategoryConst) {
        this.add = params => {
            let entity = {
                id: null,
            }
            angular.extend(entity, params)
            return this.edit(entity)
        }
        this.edit = entity => {
            return modals.open('app/agreements/agreement-category/edit-modal.html', 'AgreementCategoryDialogController', angular.copy(entity), {}, "$ctrl")
        }
        this.list = () => {
            return modals.open('app/agreements/agreement-category/list-modal.html', 'AgreementCategoryListController', {}, {size: 'md'}, "$ctrl")
        }
        this.remove = function (item) {
            return modals.confirmDelete(item.name, () => AgreementCategory.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(AgreementCategoryConst.eventUpdate)))
        }
    })
